// extracted by mini-css-extract-plugin
module.exports = {"waveform":"Waveform_waveform__RIG7A","waveAnimation":"Waveform_waveAnimation__VUGqt","waveMotion":"Waveform_waveMotion___A7z2"};